import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();
export const createProductGroupValidation = yup.object({
  name: yup.string().required(" Name is required"),
});
export const createUnitValidation = yup.object({
  name: yup.string().required(" Name is required"),
  short_code: yup.string().required("Short Code is required"),
});

export const createInventoryInfovalidation = yup.object({
  name: yup.string().required(" Name is required"),
  category: yup.string().required("Product Group is required"),
  unit: yup.string().required("Unit is required"),
});
